// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Validator from "@classes/Validator";


const collections = [
	require("./collections/CollectionKyc").default,
	require("./collections/CollectionExperience").default,
	require("./collections/CollectionAllocationProfile").default
];

export default class Fields extends React.PureComponent {
	static propTypes = {
		title: PropTypes.string.isRequired,
		validFields: PropTypes.object.isRequired,
		fields: PropTypes.object.isRequired,
		numberLocaleFormatter: PropTypes.func.isRequired,
		onFieldChange: PropTypes.func.isRequired,
		onFieldBlur: PropTypes.func.isRequired,
		onSelectChange: PropTypes.func.isRequired,
		onOptionsListChange: PropTypes.func.isRequired,
		onCheckboxChange: PropTypes.func.isRequired
	};

	static getFieldNames = _getFieldNames;
	static getHiddenDefaultFields = _getHiddenDefaultFields;
	static setupFieldsState = _setupFieldsState;

	render() {
		const {props} = this;
		const {title, fields, validFields, numberLocaleFormatter, onFieldChange, onFieldBlur, onOptionsListChange, onCheckboxChange, session, availableBanks} = props;
		const collectionProps = {
			fields,
			validFields,
			numberLocaleFormatter,
			onFieldChange,
			onFieldBlur,
			onSelectChange: this._onSelectChange,
			onOptionsListChange,
			onCheckboxChange,
			session
		};

		return (
			<div className="Cob-Fields">
				<h2>{title}</h2>

				{collections.map((Collection, index) => (
					<Collection {...collectionProps} key={index} index={index} availableBanks={availableBanks}/>
				))}
			</div>
		);
	}

	// Internal methods
	_onSelectChange = (option, index) => {
		const {onSelectChange} = this.props;
		const stateFieldKey = (
			option.name.indexOf("checkbox_customer_kyc_purpose") === 0 ? "checkbox_customer_kyc_purpose" :

				option.name.indexOf("radio_kyc_knowledge_isk") === 0 ? "radio_kyc_knowledge_isk" :
					option.name.indexOf("radio_kyc_knowledge_aktier") === 0 ? "radio_kyc_knowledge_aktier" :
						option.name.indexOf("radio_kyc_knowledge_fonder") === 0 ? "radio_kyc_knowledge_fonder" :

							option.name.indexOf("radio_kyc_transactions_aktier") === 0 ? "radio_kyc_transactions_aktier" :
								option.name.indexOf("radio_kyc_transactions_fonder") === 0 ? "radio_kyc_transactions_fonder" :
									option.name.indexOf("radio_kyc_transactions_isk") === 0 ? "radio_kyc_transactions_isk" :

										option.name.indexOf("radio_aml_transaction_size_aktier") === 0 ? "radio_aml_transaction_size_aktier" :
											option.name.indexOf("radio_aml_transaction_size_fonder") === 0 ? "radio_aml_transaction_size_fonder" :
												option.name.indexOf("radio_aml_transaction_size_isk") === 0 ? "radio_aml_transaction_size_isk" :

													option.name.indexOf("checkbox_customer_kyc_deposit") === 0 ? "checkbox_customer_kyc_deposit" :
														option.name.indexOf("checkbox_customer_kyc_empl") === 0 ? "checkbox_customer_kyc_empl" :
															null
		);

		if (stateFieldKey) {
			onSelectChange(stateFieldKey, option, index);
		}
	};

	// Static methods
	static fieldValidator = (name, value) => {
		if (name === "poa_company_socialsecuritynr") {
			return Validator.validateSsn(value, false);
		}
		else if (name === "poa_company_email") {
			return Validator.validateEmail(value);
		}
		else {
			return value.length > 0;
		}
	};
}


// PRIVATE FUNCTIONS
function _getFieldNames() {
	return [
		"customer_account_type_person",

		"newAccountCheckbox1",
		"newAccountCheckbox2",
		"newAccountCheckbox3",
		"newAccountCheckbox5",
		"newAccountSlider1",
		"newAccountSlider2",
		"newAccountSlider3",
		"newAccountSlider4",
		"newAccountSlider5",

		"checkbox_customer_kyc_purpose_financial_security",
		"checkbox_customer_kyc_purpose_relative",
		"checkbox_customer_kyc_purpose_pension",
		"checkbox_customer_kyc_purpose_private_consumption",

		"account_allocation_profile",

		"checkbox_aml_origin_savings",
		"checkbox_aml_origin_heritage_gift",
		"checkbox_aml_origin_salary",
		"checkbox_aml_origin_re_sales",
		"checkbox_aml_origin_biz_sales",
		"checkbox_aml_origin_insurance",
		"checkbox_aml_origin_capital_return",
		"checkbox_aml_origin_trading",
		"checkbox_aml_origin_gambling",
		"checkbox_aml_origin_other",
		"aml_origin_other_desc",

		"checkbox_customer_kyc_empl_other_until_further_notice",
		"checkbox_customer_kyc_empl_other_temporary_employment",
		"checkbox_customer_kyc_empl_unemployed",
		"checkbox_customer_kyc_empl_retired",
		"checkbox_customer_kyc_empl_student",
		"checkbox_customer_kyc_empl_self_employed",
		"checkbox_customer_kyc_empl_other",
		"customer_kyc_empl_other",

		"checkbox_customer_kyc_deposit_swedish_bank",
		"checkbox_customer_kyc_deposit_foreign_bank",
		"checkbox_customer_kyc_deposit_swedish_insurance",
		"checkbox_customer_kyc_deposit_foreign_insurance",
		"checkbox_customer_kyc_deposit_pension",
		"checkbox_customer_kyc_deposit_employer",

		"radio_kyc_knowledge_aktier",
		"radio_kyc_knowledge_fonder",
		"radio_kyc_knowledge_isk",

		"radio_kyc_transactions_aktier",
		"radio_kyc_transactions_fonder",
		"radio_kyc_transactions_isk",

		"radio_aml_transaction_size_aktier",
		"radio_aml_transaction_size_fonder",
		"radio_aml_transaction_size_isk",
	];
}

function _getHiddenDefaultFields() {
	return [
		// Avgiftsstruktur
		{name: "account_account_fee", value: ""},
		{name: "account_advice_fee", value: ""},
		{name: "account_disk_fee", value: ""},
		{name: "account_insurance_fee", value: ""},
		{name: "account_performance_fee", value: ""},
		{name: "account_performance_hurdle_fee", value: ""},
		{name: "account_total_fee", value: ""},

		{name: "checkbox_customer_kyc_non_proff", value: "yes"}
	];
}

function _setupFieldsState(parent) {
	let values = {
		"newAccountCheckbox1": {
			checked: true
		},
		"newAccountCheckbox2": {
			checked: true
		},
		"newAccountCheckbox3": {
			checked: false
		},
		"newAccountCheckbox5": {
			checked: true
		},
		"newAccountSlider1": "",
		"newAccountSlider2": "",
		"newAccountSlider3": "",
		"newAccountSlider4": "",
		"newAccountSlider5": "",

		"account_allocation_profile": "",

		"customer_account_type_person": {
			options: [
				{label: "ISK", value: "yes", name: "checkbox_account_isk"},
				{label: "Depåkonto", value: "yes", name: "checkbox_account_naked"}
			]
		},

		"has_account_type_selection": true,

		"radio_account_type_open": {
			options: [
				{label: "Brutto", value: "Brutto", name: "radio_account_type_open"},
				{label: "Netto", value: "Net", name: "radio_account_type_open"},
				{label: "Netto resultatbaserad", value: "NetPerf", name: "radio_account_type_open"}
			]
		},

		"checkbox_customer_kyc_purpose": {
			options: [
				{
					label: "Ekonomisk trygghet",
					value: "yes",
					name: "checkbox_aml_purpose_econ_sec",
					checked: false
				},
				{
					label: "Gåva till närstående",
					value: "yes",
					name: "checkbox_aml_purpose_gift",
					checked: false
				},
				{
					label: "Pension",
					value: "yes",
					name: "checkbox_aml_purpose_pension",
					checked: false
				},
				{
					label: "Privat konsumtion",
					value: "yes",
					name: "checkbox_aml_purpose_consump",
					checked: false
				}
			]
		},

		aml_origin_options: {
			options: [
				{
					name: "checkbox_aml_origin_interest",
					label: "Ränta/utdelningar från tidigare sparande",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_aml_origin_salary_pension",
					label: "Lön/pension",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_aml_origin_savings_herit_gift",
					label: "Arv/gåva",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_advice_origin_security_prof",
					label: "Vinst från värdepappershandel",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_advice_origin_lottery",
					label: "Lotteri/spel",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_aml_origin_re",
					label: "Bostads-/fastighetsförsäljning",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_aml_origin_companyexit",
					label: "Företagsförsäljning",
					value: "yes",
					checked: false
				},
				{
					name: "checkbox_aml_origin_insur_payment",
					label: "Försäkringsutbetalning",
					value: "yes",
					checked: false
				}
			]
		},

		radio_aml_deposit_amt: {
			options: [
				{
					name: "radio_aml_deposit_amt",
					label: "0 - 100 000 kr",
					value: "0-100",
					checked: false
				},
				{
					name: "radio_aml_deposit_amt",
					label: "100 000 - 250 000 kr",
					value: "100-250",
					checked: false
				},
				{
					name: "radio_aml_deposit_amt",
					label: "250 000 - 500 000 kr",
					value: "250-500",
					checked: false
				},
				{
					name: "radio_aml_deposit_amt",
					label: "500 000 - 1 mkr",
					value: "500-1000",
					checked: false
				},
				{
					name: "radio_aml_deposit_amt",
					label: "Mer än 1 mkr",
					value: ">1mn",
					checked: false
				}
			]
		},

		radio_aml_deposit: {
			options: [
				{
					name: "radio_aml_deposit",
					label: "Mindre än 1 gång/månad",
					value: "<1/m",
					checked: false
				},
				{
					name: "radio_aml_deposit",
					label: "1 - 5 gånger/månad",
					value: "1-5/m",
					checked: false
				},
				{
					name: "radio_aml_deposit",
					label: "Mer än 5 gånger/månad",
					value: ">5/m ",
					checked: false
				}
			]
		},

		"checkbox_customer_kyc_empl": {
			index: -1,
			options: [
				{
					label: "Tillsvidareanställd",
					value: "yes",
					name: "checkbox_customer_kyc_empl_other_until_further_notice"
				},
				{
					label: "Visstidsanställd",
					value: "yes",
					name: "checkbox_customer_kyc_empl_other_temporary_employment"
				},
				{label: "Arbetssökande", value: "yes", name: "checkbox_customer_kyc_empl_unemployed"},
				{label: "Pensionerad", value: "yes", name: "checkbox_customer_kyc_empl_retired"},
				{label: "Student", value: "yes", name: "checkbox_customer_kyc_empl_student"},
				{label: "Egen företagare", value: "yes", name: "checkbox_customer_kyc_empl_self_employed"},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_kyc_empl_other"}
			]
		},
		"customer_kyc_empl_other": "",

		"checkbox_customer_kyc_deposit": {
			options: [
				{
					label: "Svensk bank/institut",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_swedish_bank",
					checked: false
				},
				{
					label: "Utländsk bank/institut",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_foreign_bank",
					checked: false
				},
				{
					label: "Svenskt försäkringsbolag",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_swedish_insurance",
					checked: false
				},
				{
					label: "Utländskt försäkringsbolag",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_foreign_insurance",
					checked: false
				},
				{
					label: "Pension",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_pension",
					checked: false
				},
				{
					label: "Från min arbetsgivare",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_employer",
					checked: false
				}
			]
		},

		"radio_kyc_knowledge_aktier": {
			index: -1,
			options: [
				{
					label: "Ingen",
					value: "ingen",
					name: "radio_kyc_knowledge_aktier"
				},
				{
					label: "Någon",
					value: "nagon",
					name: "radio_kyc_knowledge_aktier"
				},
				{
					label: "Medel",
					value: "medel",
					name: "radio_kyc_knowledge_aktier"
				},
				{
					label: "Hög",
					value: "hog",
					name: "radio_kyc_knowledge_aktier"
				}
			]
		},
		"radio_kyc_knowledge_fonder": {
			index: -1,
			options: [
				{
					label: "Ingen",
					value: "ingen",
					name: "radio_kyc_knowledge_fonder"
				},
				{
					label: "Någon",
					value: "nagon",
					name: "radio_kyc_knowledge_fonder"
				},
				{
					label: "Medel",
					value: "medel",
					name: "radio_kyc_knowledge_fonder"
				},
				{
					label: "Hög",
					value: "hog",
					name: "radio_kyc_knowledge_fonder"
				}
			]
		},
		"radio_kyc_knowledge_isk": {
			index: -1,
			options: [
				{
					label: "Ingen",
					value: "ingen",
					name: "radio_kyc_knowledge_isk"
				},
				{
					label: "Någon",
					value: "nagon",
					name: "radio_kyc_knowledge_isk"
				},
				{
					label: "Medel",
					value: "medel",
					name: "radio_kyc_knowledge_isk"
				},
				{
					label: "Hög",
					value: "hog",
					name: "radio_kyc_knowledge_isk"
				}
			]
		},

		"radio_kyc_transactions_aktier": {
			index: -1,
			options: [
				{
					label: "0-5 st/år",
					value: "0-5",
					name: "radio_kyc_transactions_aktier"
				},
				{
					label: "6-15 st/år",
					value: "6-15",
					name: "radio_kyc_transactions_aktier"
				},
				{
					label: "16-50 st/år",
					value: "16-50",
					name: "radio_kyc_transactions_aktier"
				},
				{
					label: "Över 50 st/år",
					value: ">50",
					name: "radio_kyc_transactions_aktier"
				}
			]
		},
		"radio_kyc_transactions_fonder": {
			index: -1,
			options: [
				{
					label: "0-5 st/år",
					value: "0-5",
					name: "radio_kyc_transactions_fonder"
				},
				{
					label: "6-15 st/år",
					value: "6-15",
					name: "radio_kyc_transactions_fonder"
				},
				{
					label: "16-50 st/år",
					value: "16-50",
					name: "radio_kyc_transactions_fonder"
				},
				{
					label: "Över 50 st/år",
					value: ">50",
					name: "radio_kyc_transactions_fonder"
				}
			]
		},
		"radio_kyc_transactions_isk": {
			index: -1,
			options: [
				{
					label: "0-5 st/år",
					value: "0-5",
					name: "radio_kyc_transactions_isk"
				},
				{
					label: "6-15 st/år",
					value: "6-15",
					name: "radio_kyc_transactions_isk"
				},
				{
					label: "16-50 st/år",
					value: "16-50",
					name: "radio_kyc_transactions_isk"
				},
				{
					label: "Över 50 st/år",
					value: ">50",
					name: "radio_kyc_transactions_isk"
				}
			]
		},

		"radio_aml_transaction_size_aktier": {
			index: -1,
			options: [
				{
					label: "0 - 100'",
					value: "0-100",
					name: "radio_aml_transaction_size_aktier"
				},
				{
					label: "101' - 500'",
					value: "101-500",
					name: "radio_aml_transaction_size_aktier"
				},
				{
					label: "501' - 1 500'",
					value: "501-1500",
					name: "radio_aml_transaction_size_aktier"
				},
				{
					label: "Över 1 500'",
					value: ">1500",
					name: "radio_aml_transaction_size_aktier"
				}
			]
		},
		"radio_aml_transaction_size_fonder": {
			index: -1,
			options: [
				{
					label: "0 - 100'",
					value: "0-100",
					name: "radio_aml_transaction_size_fonder"
				},
				{
					label: "101' - 500'",
					value: "101-500",
					name: "radio_aml_transaction_size_fonder"
				},
				{
					label: "501' - 1 500'",
					value: "501-1500",
					name: "radio_aml_transaction_size_fonder"
				},
				{
					label: "Över 1 500'",
					value: ">1500",
					name: "radio_aml_transaction_size_fonder"
				}
			]
		},
		"radio_aml_transaction_size_isk": {
			index: -1,
			options: [
				{
					label: "0 - 100'",
					value: "0-100",
					name: "radio_aml_transaction_size_isk"
				},
				{
					label: "101' - 500'",
					value: "101-500",
					name: "radio_aml_transaction_size_isk"
				},
				{
					label: "501' - 1 500'",
					value: "501-1500",
					name: "radio_aml_transaction_size_isk"
				},
				{
					label: "Över 1 500'",
					value: ">1500",
					name: "radio_aml_transaction_size_isk"
				}
			]
		},

		"checkbox_aml_own_money": {options: _createYesNoOptions()},
	};

	return values;
}

function _createYesNoOptions() {
	return [
		{label: "Nej", value: "no", checked: false},
		{label: "Ja", value: "yes", checked: false}
	];
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/fair-gds-oppna/Fields/Fields.js